export default "/images/avatar.svg?a34fcedd5977e734c1282d05670786b2";